<div class="quality-control-approvals-title">
  <div class="quality-control-approvals-title-text">
    {{ titleText() }}
  </div>
  @if (!!data().id && isEditModeActive()) {
    <button
      mat-mini-fab
      class="quality-control-approvals-title-btn"
      (click)="handleDelete.emit($event)"
    >
      <mat-icon class="quality-control-approvals-title-btn-icon">
        delete
      </mat-icon>
    </button>
  }
</div>
